import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(initializeAuth),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(initalizeTitanFromCookie),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(updateCookieFromAccount),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(completeSuccessfulLogin),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(saveProductRightsToStorage),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(consolidatedLogin),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(refreshUser),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(updateUser),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(logout),
    _marked10 = /*#__PURE__*/_regeneratorRuntime.mark(authSagas);

import { delay } from 'redux-saga';
import { call, put, select, spawn, takeEvery, takeLatest } from 'redux-saga/effects';
import { authActions, authSelectors, INIT_AUTH, CONSOLIDATED_LOGIN, LOGIN_STATUS, ACCOUNT_TYPE, LOGOUT, REFRESH_USER, UPDATE_USER } from '../reducer/auth-reducer';

import { getConsolidatedLoginData, getAccessTokenWithCreds, deleteAccessToken, saveLoginCookie, deleteLoginCookie, getProductRights, deleteStoredLoginInfo, saveStoredLoginInfo, getLoginCookie, getStoredLoginInfo, getAccessTokenData, getUserInfo, updateUserInfo } from '../services/auth-helpers';

function initializeAuth() {
  var loginCookie, hasNoTitanCreds, isRememberMe;
  return _regeneratorRuntime.wrap(function initializeAuth$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return call(getLoginCookie);

        case 2:
          loginCookie = _context.sent;
          hasNoTitanCreds = !loginCookie || !loginCookie.userId || !loginCookie.access_token;
          isRememberMe = loginCookie && loginCookie.rm_key && loginCookie.rm_guid;

          // Return early in generator to avoid timing issues.

          if (!(hasNoTitanCreds && !isRememberMe)) {
            _context.next = 11;
            break;
          }

          _context.next = 8;
          return call(logout);

        case 8:
          _context.next = 10;
          return put(authActions.initComplete());

        case 10:
          return _context.abrupt('return', _context.sent);

        case 11:
          if (!isRememberMe) {
            _context.next = 16;
            break;
          }

          _context.next = 14;
          return call(consolidatedLogin, {
            payload: {
              rememberMeCookie: loginCookie
            }
          });

        case 14:
          _context.next = 22;
          break;

        case 16:
          if (!(loginCookie && !loginCookie.userId && !loginCookie.access_token)) {
            _context.next = 19;
            break;
          }

          _context.next = 22;
          break;

        case 19:
          if (!(loginCookie && loginCookie.userId && loginCookie.access_token)) {
            _context.next = 22;
            break;
          }

          _context.next = 22;
          return call(initalizeTitanFromCookie);

        case 22:
          _context.next = 24;
          return put(authActions.initComplete());

        case 24:
          return _context.abrupt('return', _context.sent);

        case 25:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function initalizeTitanFromCookie() {
  var loginCookie, loginInfo, storageName, storedLoginInfo, tullyHost, tokenResponse;
  return _regeneratorRuntime.wrap(function initalizeTitanFromCookie$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return call(getLoginCookie);

        case 2:
          loginCookie = _context2.sent;
          _context2.prev = 3;
          loginInfo = null;
          _context2.next = 7;
          return select(authSelectors.appId);

        case 7:
          storageName = _context2.sent;
          _context2.next = 10;
          return call(getStoredLoginInfo, storageName);

        case 10:
          storedLoginInfo = _context2.sent;

          if (!(storedLoginInfo && storedLoginInfo.userId === loginCookie.userId && storedLoginInfo.access_token === loginCookie.access_token)) {
            _context2.next = 15;
            break;
          }

          loginInfo = storedLoginInfo;
          _context2.next = 24;
          break;

        case 15:
          _context2.next = 17;
          return select(authSelectors.tullyHost);

        case 17:
          tullyHost = _context2.sent;
          _context2.next = 20;
          return call(getAccessTokenData, loginCookie.access_token, tullyHost);

        case 20:
          tokenResponse = _context2.sent;
          _context2.next = 23;
          return call(saveProductRightsToStorage, tokenResponse);

        case 23:
          loginInfo = _context2.sent;

        case 24:
          _context2.next = 26;
          return call(completeSuccessfulLogin, loginInfo);

        case 26:
          _context2.next = 32;
          break;

        case 28:
          _context2.prev = 28;
          _context2.t0 = _context2['catch'](3);
          _context2.next = 32;
          return call(logout);

        case 32:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[3, 28]]);
}

// Persist some account data in the cookie.
function updateCookieFromAccount(userInfo) {
  var loginCookie;
  return _regeneratorRuntime.wrap(function updateCookieFromAccount$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return call(getLoginCookie);

        case 2:
          loginCookie = _context3.sent;

          if (!(userInfo.interfaceLanguage !== loginCookie.interfaceLanguage)) {
            _context3.next = 6;
            break;
          }

          _context3.next = 6;
          return call(saveLoginCookie, { interfaceLanguage: userInfo.interfaceLanguage });

        case 6:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

// finish login once we have a token and have product rights
//  it is the part of the process shared by page-reload
//  and creds login so it is broken out
function completeSuccessfulLogin(loginInfo) {
  var egoHost, userInfo;
  return _regeneratorRuntime.wrap(function completeSuccessfulLogin$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return select(authSelectors.egoHost);

        case 3:
          egoHost = _context4.sent;
          _context4.next = 6;
          return call(getUserInfo, loginInfo.userId, loginInfo.access_token, egoHost);

        case 6:
          userInfo = _context4.sent;

          // add roles to user for backward compatibility
          userInfo.roles = loginInfo.roles;
          _context4.next = 10;
          return put(authActions.setUserInfo(userInfo));

        case 10:
          _context4.next = 12;
          return call(updateCookieFromAccount, userInfo);

        case 12:
          _context4.next = 20;
          break;

        case 14:
          _context4.prev = 14;
          _context4.t0 = _context4['catch'](0);
          _context4.next = 18;
          return put(authActions.setAuthError(_context4.t0.message));

        case 18:
          _context4.next = 20;
          return call(logout);

        case 20:
          _context4.next = 22;
          return put(authActions.setAuthToken(loginInfo.access_token));

        case 22:
          _context4.next = 24;
          return put(authActions.setRefreshToken(loginInfo.refresh_token));

        case 24:
          _context4.next = 26;
          return put(authActions.setAccountType(ACCOUNT_TYPE.CATALYST));

        case 26:
          _context4.next = 28;
          return put(authActions.setLoginStatus(LOGIN_STATUS.LOGGED_IN));

        case 28:
          _context4.next = 30;
          return put(authActions.setClientId(loginInfo.client_id));

        case 30:
          _context4.next = 32;
          return put(authActions.setProductRights(loginInfo.productRights));

        case 32:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[0, 14]]);
}

function saveProductRightsToStorage(tokenResponse) {
  var sirenHost, productRightsResponse, appId, loginInfo;
  return _regeneratorRuntime.wrap(function saveProductRightsToStorage$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return select(authSelectors.sirenHost);

        case 2:
          sirenHost = _context5.sent;
          _context5.next = 5;
          return call(getProductRights, tokenResponse.userId, tokenResponse.access_token, sirenHost);

        case 5:
          productRightsResponse = _context5.sent;
          _context5.next = 8;
          return select(authSelectors.appId);

        case 8:
          appId = _context5.sent;
          _context5.next = 11;
          return call(saveStoredLoginInfo, appId, tokenResponse, productRightsResponse.productRights);

        case 11:
          loginInfo = _context5.sent;
          return _context5.abrupt('return', loginInfo);

        case 13:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

/**
 * If rememberMeCookie (an object) is passed, we will send cookie.key and cookie.guid
 * to LPS. Otherwise, we will attempt sign in with a username/email and password
 */
function consolidatedLogin(action) {
  var username, password, namespace, accountType, rememberMeChecked, rememberMeCookie, loginResponse, lpsHost, acc, remember_me, tokenResponse, cookieData, _cookieData, loginInfo, totaleHost, totaleUrl, loginCookie, _cookieData2, _cookieData3;

  return _regeneratorRuntime.wrap(function consolidatedLogin$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          username = action.payload.username;
          password = action.payload.password;
          namespace = action.payload.namespace;
          accountType = action.payload.accountType;
          rememberMeChecked = action.payload.rememberMeChecked;
          rememberMeCookie = action.payload.rememberMeCookie || null;
          _context6.next = 8;
          return put(authActions.setLoginStatus(LOGIN_STATUS.PENDING));

        case 8:
          _context6.prev = 8;

          // Send the login request to the LPS. Expect either a single account with token, or a list of accounts without token
          loginResponse = null;
          _context6.next = 12;
          return select(authSelectors.lpsHost);

        case 12:
          lpsHost = _context6.sent;

          if (!rememberMeCookie) {
            _context6.next = 19;
            break;
          }

          _context6.next = 16;
          return call(getConsolidatedLoginData, '', '', '', '', '', rememberMeCookie, lpsHost);

        case 16:
          loginResponse = _context6.sent;
          _context6.next = 22;
          break;

        case 19:
          _context6.next = 21;
          return call(getConsolidatedLoginData, username, password, namespace, accountType, rememberMeChecked, null, lpsHost);

        case 21:
          loginResponse = _context6.sent;

        case 22:
          if (!(loginResponse.account_list.length === 0)) {
            _context6.next = 29;
            break;
          }

          _context6.next = 25;
          return put(authActions.setAuthError("invalid_grant"));

        case 25:
          _context6.next = 27;
          return call(logout);

        case 27:
          _context6.next = 96;
          break;

        case 29:
          if (!(loginResponse.auth_token != null && loginResponse.account_list.length === 1)) {
            _context6.next = 92;
            break;
          }

          acc = loginResponse.account_list[0];
          remember_me = loginResponse.remember_me || null;
          _context6.t0 = acc.account_type;
          _context6.next = _context6.t0 === ACCOUNT_TYPE.CATALYST ? 35 : _context6.t0 === ACCOUNT_TYPE.CONSUMER ? 51 : _context6.t0 === ACCOUNT_TYPE.STANDALONE ? 75 : 86;
          break;

        case 35:
          tokenResponse = loginResponse.auth_data;

          if (!remember_me) {
            _context6.next = 42;
            break;
          }

          // Keep the CachedAuth data
          cookieData = {
            access_token: tokenResponse.access_token,
            userId: tokenResponse.userId,
            rm_key: remember_me.key,
            rm_guid: remember_me.guid,
            expires: remember_me.expires_at,
            account_type: ACCOUNT_TYPE.CATALYST
          };
          _context6.next = 40;
          return call(saveLoginCookie, cookieData);

        case 40:
          _context6.next = 45;
          break;

        case 42:
          // Just keep regular token data
          _cookieData = {
            access_token: tokenResponse.access_token,
            userId: tokenResponse.userId,
            rm_key: null,
            rm_guid: null,
            expires: null,
            account_type: ACCOUNT_TYPE.CATALYST
          };
          _context6.next = 45;
          return call(saveLoginCookie, _cookieData);

        case 45:
          _context6.next = 47;
          return call(saveProductRightsToStorage, tokenResponse);

        case 47:
          loginInfo = _context6.sent;
          _context6.next = 50;
          return call(completeSuccessfulLogin, loginInfo);

        case 50:
          return _context6.abrupt('break', 90);

        case 51:
          _context6.next = 53;
          return select(authSelectors.totaleHost);

        case 53:
          totaleHost = _context6.sent;
          totaleUrl = totaleHost + '/token_authentication?authToken=' + loginResponse.auth_token;
          // If it is set, pull the interfaceLanguage from the cookie

          _context6.next = 57;
          return call(getLoginCookie);

        case 57:
          loginCookie = _context6.sent;

          if (loginCookie && loginCookie.interfaceLanguage) {
            totaleUrl += '&locale=' + loginCookie.interfaceLanguage;
          }

          if (!remember_me) {
            _context6.next = 65;
            break;
          }

          _cookieData2 = {
            access_token: null,
            userId: null,
            rm_key: remember_me.key,
            rm_guid: remember_me.guid,
            expires: remember_me.expires_at,
            account_type: ACCOUNT_TYPE.CONSUMER
          };
          _context6.next = 63;
          return call(saveLoginCookie, _cookieData2);

        case 63:
          _context6.next = 68;
          break;

        case 65:
          if (!(loginCookie && !loginCookie.rm_key || !loginCookie)) {
            _context6.next = 68;
            break;
          }

          _context6.next = 68;
          return call(saveLoginCookie, {
            userId: null,
            access_token: null,
            rm_key: null,
            rm_guid: null,
            expires_at: null,
            account_type: ACCOUNT_TYPE.CONSUMER
          });

        case 68:
          _context6.next = 70;
          return put(authActions.setAccountType(ACCOUNT_TYPE.CONSUMER));

        case 70:
          _context6.next = 72;
          return put(authActions.setLoginRedirectUrl(totaleUrl));

        case 72:
          _context6.next = 74;
          return put(authActions.setLoginStatus(LOGIN_STATUS.LOGGED_IN));

        case 74:
          return _context6.abrupt('break', 90);

        case 75:
          if (!remember_me) {
            _context6.next = 79;
            break;
          }

          _cookieData3 = {
            access_token: null,
            userId: null,
            rm_key: remember_me.key,
            rm_guid: remember_me.guid,
            expires: remember_me.expires_at,
            account_type: ACCOUNT_TYPE.STANDALONE
          };
          _context6.next = 79;
          return call(saveLoginCookie, _cookieData3);

        case 79:
          _context6.next = 81;
          return put(authActions.setAccountType(ACCOUNT_TYPE.STANDALONE));

        case 81:
          _context6.next = 83;
          return put(authActions.setLoginRedirectUrl(loginResponse.portal_login_url + '?token=' + loginResponse.auth_token));

        case 83:
          _context6.next = 85;
          return put(authActions.setLoginStatus(LOGIN_STATUS.LOGGED_IN));

        case 85:
          return _context6.abrupt('break', 90);

        case 86:
          _context6.next = 88;
          return put(authActions.setAuthError(ex.message));

        case 88:
          _context6.next = 90;
          return call(logout);

        case 90:
          _context6.next = 96;
          break;

        case 92:
          _context6.next = 94;
          return put(authActions.setAccountList(loginResponse.account_list));

        case 94:
          _context6.next = 96;
          return put(authActions.setLoginStatus(LOGIN_STATUS.ACCOUNT_CHOOSE));

        case 96:
          _context6.next = 104;
          break;

        case 98:
          _context6.prev = 98;
          _context6.t1 = _context6['catch'](8);
          _context6.next = 102;
          return put(authActions.setAuthError(_context6.t1.message));

        case 102:
          _context6.next = 104;
          return call(logout);

        case 104:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this, [[8, 98]]);
}

/*
  If you need to reload the user - say for example you called LPS to
    reset the user's targetLanguage.  LPS does many things so reloading the
    user afterwards is good.

    This expects the user to be successfully logged in and will complain if they are not.

    When completed, it will send the AUTH_INIT_COMPLETE action - wait for that.
 */
function refreshUser() {
  var status, appId;
  return _regeneratorRuntime.wrap(function refreshUser$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return select(authSelectors.loginStatus);

        case 2:
          status = _context7.sent;

          if (!(status !== LOGIN_STATUS.LOGGED_IN)) {
            _context7.next = 9;
            break;
          }

          _context7.next = 6;
          return put(authActions.setAuthError('attempt to refreshUser with no logged-in user'));

        case 6:
          _context7.next = 8;
          return put(authActions.initComplete());

        case 8:
          return _context7.abrupt('return', _context7.sent);

        case 9:
          _context7.next = 11;
          return select(authSelectors.appId);

        case 11:
          appId = _context7.sent;
          _context7.next = 14;
          return call(deleteStoredLoginInfo, appId);

        case 14:
          _context7.next = 16;
          return call(initializeAuth);

        case 16:
          return _context7.abrupt('return', _context7.sent);

        case 17:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function updateUser(action) {
  var userId, newProps, egoHost, token, currentInfo, newUserInfo;
  return _regeneratorRuntime.wrap(function updateUser$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return select(authSelectors.userId);

        case 2:
          userId = _context8.sent;

          if (userId) {
            _context8.next = 7;
            break;
          }

          _context8.next = 6;
          return put(authActions.userUpdateComplete());

        case 6:
          return _context8.abrupt('return', _context8.sent);

        case 7:
          newProps = action.payload;
          _context8.next = 10;
          return select(authSelectors.egoHost);

        case 10:
          egoHost = _context8.sent;
          _context8.next = 13;
          return select(authSelectors.authToken);

        case 13:
          token = _context8.sent;
          _context8.prev = 14;
          _context8.next = 17;
          return call(updateUserInfo, userId, newProps, token, egoHost);

        case 17:
          _context8.next = 19;
          return select(authSelectors.userInfo);

        case 19:
          currentInfo = _context8.sent;
          newUserInfo = _extends({}, currentInfo, newProps);
          _context8.next = 23;
          return put(authActions.setUserInfo(newUserInfo));

        case 23:
          _context8.next = 25;
          return call(updateCookieFromAccount, newUserInfo);

        case 25:
          _context8.next = 31;
          break;

        case 27:
          _context8.prev = 27;
          _context8.t0 = _context8['catch'](14);
          _context8.next = 31;
          return put(authActions.setAuthError(_context8.t0.message));

        case 31:
          _context8.next = 33;
          return put(authActions.userUpdateComplete());

        case 33:
          return _context8.abrupt('return', _context8.sent);

        case 34:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this, [[14, 27]]);
}

function logout() {
  var tullyHost, wasSsoUser, userInfo, appId;
  return _regeneratorRuntime.wrap(function logout$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return select(authSelectors.tullyHost);

        case 3:
          tullyHost = _context9.sent;
          _context9.next = 6;
          return call(deleteAccessToken, tullyHost);

        case 6:
          _context9.next = 10;
          break;

        case 8:
          _context9.prev = 8;
          _context9.t0 = _context9['catch'](0);

        case 10:
          wasSsoUser = false;
          _context9.next = 13;
          return select(authSelectors.userInfo);

        case 13:
          userInfo = _context9.sent;

          if (userInfo) {
            wasSsoUser = userInfo.externalIds && userInfo.externalIds.sso;
          }
          _context9.next = 17;
          return call(deleteLoginCookie);

        case 17:
          _context9.next = 19;
          return select(authSelectors.appId);

        case 19:
          appId = _context9.sent;
          _context9.next = 22;
          return call(deleteStoredLoginInfo, appId);

        case 22:
          _context9.next = 24;
          return put(authActions.setUserInfo(undefined));

        case 24:
          _context9.next = 26;
          return put(authActions.removeAuthToken());

        case 26:
          _context9.next = 28;
          return put(authActions.removeRefreshToken());

        case 28:
          _context9.next = 30;
          return put(authActions.setAccountType(undefined));

        case 30:
          _context9.next = 32;
          return put(authActions.setLoginStatus(LOGIN_STATUS.LOGGED_OUT));

        case 32:
          _context9.next = 34;
          return put(authActions.logoutComplete(wasSsoUser));

        case 34:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this, [[0, 8]]);
}

export function authSagas() {
  return _regeneratorRuntime.wrap(function authSagas$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return takeLatest(INIT_AUTH, initializeAuth);

        case 2:
          _context10.next = 4;
          return takeLatest(UPDATE_USER, updateUser);

        case 4:
          _context10.next = 6;
          return takeLatest(REFRESH_USER, refreshUser);

        case 6:
          _context10.next = 8;
          return takeLatest(CONSOLIDATED_LOGIN, consolidatedLogin);

        case 8:
          _context10.next = 10;
          return takeEvery(LOGOUT, logout);

        case 10:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/react-auth/es/sagas/auth-sagas.js
// module id = 628
// module chunks = 0